/**
 * ## Wizard Controller
 *
 * @module src/controllers/wizard
 */

"use strict";

const modal = require("../../components/modal");
const notification = require("../../components/notification");
const layout = require("../../components/layout");
const l = require("../../common").localization;
const conf = require("../../config");

let kd;
let step = 0;
let lastClick = 0;
let active = false;
let selector = null;
const offset = {
  top: 0,
  left: 0,
  width: false,
};

const setGuideStatus = (bool) => {
  kd.localstore.data.guide = bool;
  kd.localstore.flush();
};

const getTable = (opt) => {
  let id = null;
  let c = 0;
  $(opt.target).each((i, obj) => {
    if (
      obj.id.indexOf(opt.match) > -1 &&
      $(`#${obj.id}`).data("type") !== "icon" &&
      !id
    ) {
      if (c === opt.index) {
        id = obj.id;
      }
      ++c;
    }
  });
  return id;
};

const highlight = (opt) => {
  setTimeout(() => {
    if (opt.hasOwnProperty("selector") && opt.selector) {
      selector = opt.selector;
      offset.top = opt.topOffset;
      offset.left = opt.leftOffset;
      $(`#guide${opt.type}`).css("display", "block");
      $(`#guide${opt.type}`).css(
        "top",
        $(opt.selector).offset().top + opt.topOffset
      );
      $(`#guide${opt.type}`).css(
        "left",
        $(opt.selector).offset().left + opt.leftOffset
      );
      if (opt.hasOwnProperty("width")) {
        offset.width = opt.width;
        $(`#guide${opt.type}`).css("width", opt.width);
        $(`#guide${opt.type}`).css("height", opt.height);
      } else {
        offset.width = false;
        $(`#guide${opt.type}`).css("width", $(opt.selector).outerWidth());
        $(`#guide${opt.type}`).css("height", $(opt.selector).outerHeight());
      }
      TweenMax.to(`#guide${opt.type}`, 0, {
        alpha: 1,
        scale: 2,
      });
      TweenMax.to(`#guide${opt.type}`, conf.vars.interfaceSpeed * 1.5, {
        alpha: 1,
        scale: 1,
        ease: Elastic.easeOut,
      });
    }
    $(`#guide${opt.type}`).fastClick((e) => {
      $(`#guide${opt.type}`).off();
      $(`#guide${opt.type}`).off("fastClick");
      $(`#guide${opt.type}`).css("display", "none");
      if (opt.hasOwnProperty("altClick") && opt.altClick) {
        if (opt.hasOwnProperty("touchSelector")) {
          $(opt.touchSelector).mousedown();
          $(opt.touchSelector).mouseup();
        } else {
          $(opt.selector).mousedown();
          $(opt.selector).mouseup();
        }
      } else {
        if (opt.hasOwnProperty("touchSelector")) {
          $(opt.touchSelector).click();
        } else {
          $(opt.selector).click();
        }
      }
      nextStep();
    });
  }, 100);
};

const guide = [
  () => {
    $("#modal_block").css("display", "none");
    const opt = {
      width: "80%",
      type: "dialog",
      h1: l.translate("Welcome to Guest List"),
      body: l.translate(
        "Are you new to Guest List? If you are a manager and this is " +
          "your first time " +
          "logging in, we recommend you start with the Settings Dashboard " +
          "and configure your account. If has been completed, use the " +
          "`Guestlist Guide` button to start a walkthrough. " +
          "Pressing `Never Show Again` will only affect this device."
      ),
      buttons: [
        {
          description: l.translate("Settings Dashboard"),
          value: "dashboard",
        },
        {
          description: l.translate("Never Show Again"),
          value: "never",
        },
        {
          description: l.translate("Guest List Guide"),
          value: "tour",
        },
      ],
    };

    modal.create(opt, {}, (err, value) => {
      modal.destroy();
      switch (value.button) {
        case "cancel": {
          destroy();
          break;
        }
        case "dashboard": {
          destroy();
          const hostname = window.location.hostname.replace(
            "guestlist",
            "guestlistdashboard"
          );
          if (conf.vars.NODE_ENV.indexOf("ios") > -1) {
            window.open("https://guestlistdashboard.heartland.us", "_system");
          } else if (conf.vars.NODE_ENV.indexOf("android") > -1) {
            navigator.app.loadUrl("https://guestlistdashboard.heartland.us", {
              openExternal: true,
            });
          } else {
            window.open(`https://${hostname}`, "_blank");
          }
          break;
        }
        case "tour": {
          $("#guide_block").css("display", "block");
          nextStep();
          break;
        }
        case "never": {
          destroy();
          setGuideStatus(true);
          break;
        }
        default: {
          break;
        }
      }
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("How to direct seat a party"),
      body: l.translate(
        "Touch the highlighted table to bring up a context menu."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    const id0 = getTable({
      target: ".table_lib",
      match: "table_",
      index: 0,
    });
    highlight({
      type: 1,
      altClick: true,
      selector: `#${id0}`,
      touchSelector: `#${id0} > .table_base > .svg > .table > .top`,
      topOffset: 34,
      leftOffset: 34,
      width: 60,
      height: 60,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Select a party size"),
      body: l.translate("Select `2` to seat a party of 2 at this table"),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#size2",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("The table is now occupied"),
      body: l.translate(
        "Touching the table at any time will bring up more options. " +
          "Touch the table again."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {
      nextStep();
    });
    const id0 = getTable({
      target: ".table_lib",
      match: "table_",
      index: 0,
    });
    highlight({
      type: 1,
      altClick: true,
      selector: `#${id0}`,
      touchSelector: `#${id0} > .table_base > .svg > .table > .top`,
      topOffset: 34,
      leftOffset: 34,
      width: 60,
      height: 60,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Clearing a table"),
      body: l.translate(
        "This context menu will allow you to change table status, " +
          "edit details, and more. Select `Open` to clear the table you just sat."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#context_table_status_btn0",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Success!"),
      body: l.translate("You just sat and then cleared a table. Nice!"),
      buttons: [
        {
          description: l.translate("End Guide"),
          value: "cancel",
        },
        {
          description: l.translate("Next"),
          value: "next",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      switch (value) {
        case "cancel": {
          destroy();
          break;
        }
        case "next": {
          nextStep();
          break;
        }
        default: {
          break;
        }
      }
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Add to the waitlist"),
      body: l.translate(
        "Adding a party to the queue is very easy. Start by touching the " +
          "highlighted blue button in the lower right hand corner."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#tab_btn_addparty_wide",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Add to the waitlist"),
      body: l.translate(
        "Party name and details are entered here. A party name " +
          "has already been filled. If no cell number is entered, " +
          "the alert type will automatically change to Guest Waiting. " +
          "Press the add party button to continue."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    setTimeout(() => {
      $("#modal_addparty_name").val("Susan J.");
      layout.hideKeyboard();
      highlight({
        type: 1,
        selector: "#modal_addparty_btn2",
        topOffset: 0,
        leftOffset: 0,
      });
    }, 200);
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("You added a party to the Wait List!"),
        body: l.translate(
          "The party is now highlighted in the wait list. " +
            "Select the party."
        ),
        buttons: [],
      };
      notification.create(opt, {}, (err, value) => {});
      highlight({
        type: 1,
        selector: "#block_item_waiting_1-2_0",
        topOffset: 0,
        leftOffset: 0,
      });
    }, 3000);
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Alerting a party"),
      body: l.translate(
        "To alert a party, select Send Alert. Since we did not enter a " +
          "cell number, we will be prompted to announce the waiting parties name. If this " +
          "party had a cell number entered, Guest List would have sent an alert text message."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#context_waitlist_moveparty_btn3",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "70%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("Reservation tab"),
        body: l.translate("Start by selecting the Reservation tab"),
        buttons: [],
      };
      notification.create(opt, {}, (err, value) => {});
      highlight({
        type: 1,
        selector: "#tab_standard_reservations",
        topOffset: 0,
        leftOffset: 0,
      });
    }, 3000);
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Add a reservation"),
      body: l.translate(
        "Adding a party to the queue is very easy. Start by touching the " +
          "highlighted green button in the lower right hand corner."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#tab_btn_addreservation_wide",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Add a reservation"),
      body: l.translate(
        "Party name and details are entered here. A party name " +
          "has already been filled in. The date can be left alone, but go ahead and select " +
          "a time."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    setTimeout(() => {
      $("#modal_addparty_name").val("Susan J.");
      $("#modal_addparty_createdBy").val("Ken");
      document.activeElement.blur();
      $("input").blur();
    }, 200);
    highlight({
      type: 1,
      selector: "#modal_addparty_time",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("Selecting a reservation time"),
        body: l.translate(
          "Inventory will be shown right on the time selector, with " +
            "unavailable or full times shown as black. For now, choose 7:00pm"
        ),
        buttons: [],
      };
      notification.create(opt, {}, (err, value) => {});
      setTimeout(() => {
        $("#modal_addparty_name").val("Susan J.");
        $("#reservation_override").prop("checked", true);
        document.activeElement.blur();
        $("input").blur();
      }, 200);
      highlight({
        type: 1,
        selector: "#time80",
        topOffset: 0,
        leftOffset: 0,
      });
    }, 500);
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Add the reservation"),
      body: l.translate(
        "More details can be added including in the needs tabs, but for " +
          "now let's add the reservation as is."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    setTimeout(() => {
      $("#modal_addparty_name").val("Susan J.");
      document.activeElement.blur();
      $("input").blur();
    }, 200);
    highlight({
      type: 1,
      selector: "#modal_addparty_btn2",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("Other areas"),
        body: l.translate(
          "There are other areas in Guest List for different " +
            "operations. Access that menu here."
        ),
        buttons: [],
      };
      notification.create(opt, {}, (err, value) => {});
      highlight({
        type: 1,
        selector: "#tab_standard_more",
        topOffset: 0,
        leftOffset: 0,
      });
    }, 3000);
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Direct Seating"),
      body: l.translate(
        "Each of these areas does something different. Let us start " +
          "with the Direct Seating option."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#tab_btn_direct",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Direct Seating"),
      body: l.translate(
        "The top area lists the priority order of the next sections to " +
          "be sat. This allows for optimum turns times and a fair rotation to the serving " +
          "staff. The lower section " +
          "shows the next recommended table for various party sizes. Not all sections have " +
          "all table sizes available so the recommendations may be different for each party " +
          "size range. Selecting a specific size will automatically seat that size party " +
          "at the recommended table. Go ahead and press the highlighted 2."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#directseat_size2",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("Great Job!"),
        body: l.translate("You seated a party of 2 at the recommended table."),
        buttons: [
          {
            description: l.translate("End Guide"),
            value: "cancel",
          },
          {
            description: l.translate("Next"),
            value: "next",
          },
        ],
      };
      notification.create(opt, {}, (err, value) => {
        switch (value) {
          case "cancel": {
            destroy();
            break;
          }
          case "next": {
            nextStep();
            break;
          }
          default: {
            break;
          }
        }
      });
    }, 2500);
  },
  () => {
    const opt = {
      position: "bottom",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Wide Tabs"),
      body: l.translate(
        "Some of the tabs had wider versions that include more details. " +
          "Select the icon to expand to the wide versions."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#layout_sidebar_header_expand",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    const opt = {
      position: "bottom",
      width: "90%",
      seconds: 0,
      color: "#34d8cd",
      h1: l.translate("Wide Tabs"),
      body: l.translate(
        "This view will show a more detailed version of the Wait List. " +
          "Some views only have a narrow version. That is indicated by the arrow icon " +
          "in the tab. Go ahead and minimize the wide tab view."
      ),
      buttons: [],
    };
    notification.create(opt, {}, (err, value) => {});
    highlight({
      type: 1,
      selector: "#layout_sidebar_header_expand",
      topOffset: 0,
      leftOffset: 0,
    });
  },
  () => {
    setTimeout(() => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        color: "#34d8cd",
        h1: l.translate("You did it!"),
        body: l.translate(
          "The guide is complete and you now have a basic understanding " +
            "Guest List."
        ),
        buttons: [
          {
            description: l.translate("Close"),
            value: "cancel",
          },
        ],
      };
      notification.create(opt, {}, (err, value) => {
        destroy();
        layout.resize();
        setGuideStatus(true);
      });
    }, 1000);
  },
];

const nextStep = () => {
  if (Date.now() - lastClick > 1000) {
    lastClick = Date.now();
    if (step >= guide.length) {
      destroy();
    } else {
      guide[step]();
      ++step;
    }
  }
};

const destroy = () => {
  active = false;
  notification.destroy();
  $("#guide_block").css("display", "none");
};

const start = () => {
  active = true;
  // $('#guide_block').css('display', 'block');
  $("#guide_block").fastClick((e) => {
    e.preventDefault;
  });
  nextStep();
};

const checkResize = () => {
  setTimeout(() => {
    if (active) {
      $("#guide1").css("top", $(selector).offset().top + offset.top);
      $("#guide1").css("left", $(selector).offset().left + offset.left);
      if (offset.hasOwnProperty("width") && offset.width) {
        $("#guide1").css("width", offset.width);
        $("#guide1").css("height", offset.height);
      } else {
        $("#guide1").css("width", $(selector).outerWidth());
        $("#guide1").css("height", $(selector).outerHeight());
      }
    }
  }, 1);
};

window.addEventListener("orientationchange", checkResize);

$(window).resize(checkResize);

/** Init
 */
const init = (kdObj) => {
  kd = kdObj;
  setTimeout(() => {
    if (
      !kd.localstore.data.hasOwnProperty("guide") &&
      kd.usage === "standard"
    ) {
      start();
    }
  }, 2000);
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/wizard/index.js
 **/